import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgModel } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { InspectionFilter } from './';

@Component({
    selector: 'inspection-filter-component',
    templateUrl: 'filter.component.html',
    standalone: false
})
export class InspectionFilterComponent implements AfterViewInit {
  @Input() filter: InspectionFilter;
  @Output() toggleSearch = new EventEmitter();
  @Output() openFilter = new EventEmitter();
  @Output() toggleClose = new EventEmitter();
  @Output() resetFilters = new EventEmitter();
  @ViewChild(NgModel, { static: true }) searchInput: NgModel;

  ngAfterViewInit(): void {
    setTimeout(() =>
      this.searchInput.valueChanges
        .pipe(debounceTime(500), distinctUntilChanged())
        .subscribe((value) => this.toggleSearch.emit())
    );
  }

  get filtersApplied() {
    return !!Object.keys(this.filter).length;
  }
}
